/**
 * @file index
 * @author WangZhuang
 */

import * as buy from './buy';
import * as help from './help';
import * as page from './page';
import * as mark from './mark';
import * as home from './home';
import * as apply from './apply';
import * as forum from './forum';
import * as search from './search';
import * as product from './product';
import * as fileCheck from './fileCheck';
import * as community from './community';
import * as numberAuth from './numberAuth';
import * as productCenter from './productCenter';
import * as productDetail from './productDetail';
import * as numberOptions from './numberOptions';

export default Object.assign(
    {},
    buy,
    page,
    mark,
    home,
    help,
    apply,
    forum,
    search,
    product,
    fileCheck,
    community,
    numberAuth,
    productCenter,
    productDetail,
    numberOptions
);



// WEBPACK FOOTER //
// ./src/reducers/index.js